/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar2(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M20 19s2.568-1.202 2-4c-.719-3.54-4.405-10-10-10S2.718 11.46 2 15c-.568 2.798 2 4 2 4s1.006-4 8-4 8 4 8 4z" opacity=".3"/><path d="M20 20H4a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2z"/><path d="M20 20a.996.996 0 0 1-.967-.744C18.986 19.095 18.009 16 12 16c-6.038 0-6.996 3.125-7.034 3.258a1.02 1.02 0 0 1-.549.645 1 1 0 0 1-.841.003c-1.135-.53-3.13-2.281-2.556-5.104C1.783 11.035 5.788 4 12 4c6.21 0 10.215 7.035 10.98 10.801.573 2.823-1.422 4.574-2.557 5.104A.975.975 0 0 1 20 20zM12 6c-4.994 0-8.39 6.092-9.02 9.198-.222 1.09.201 1.84.646 2.303C4.551 16.09 6.798 14 12 14c5.2 0 7.447 2.088 8.372 3.499.447-.466.868-1.215.648-2.3C20.389 12.092 16.992 6 12 6z"/><path d="m15.03 13.242-.572-2.286-1.751 1.751a.999.999 0 0 1-1.414 0l-1.751-1.751-.572 2.286-1.94-.484 1-4a1 1 0 0 1 1.677-.465L12 10.586l2.293-2.293a.998.998 0 0 1 1.677.465l1 4-1.94.484z"/></svg>
  );
}

export default Avatar_icn_avatar2;
